exports = module.exports = require("../../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".download-view{height:100%}.download-view .selection-lists{height:calc(100% - 23px);overflow-y:auto;margin-left:-5px}.download-view .selection-lists.with-terms{height:calc(100% - 60px)}.download-view .selection-norecords{color:#fff;padding:5px}.download-control{position:absolute;width:calc(100% - 10px);margin-bottom:5px;bottom:0}.download-control .checkbox{width:100%}.selection-items,.selection-lists .panel{margin-bottom:0!important}.btn-download-full-res,.btn-processing{width:calc(100% - 10px);margin:5px 0 0 5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /~/css-loader!/~/postcss-loader!/~/eoxc/src/download/views/DownloadSelectionView.css
// module id = 1980
// module chunks = 0